<template>
  <div class="operation-wrap">
    <WechatLogin
      v-if="status === 'login' && loginMode === 'wechat'"
      @success="$emit('next')"
      @accountSelect="onSelectAccount"
      @switch="onChangeLoginModeClick"
    ></WechatLogin>
    <AccountLogin
      v-if="status === 'login' && loginMode === 'pwd'"
      @back="status = 'resetPwd'"
      @success="$emit('next')"
      @accountSelect="onSelectAccount"
      @switch="onChangeLoginModeClick"
    />
    <SelectAccount v-model:open="open" @select="onSelect" />
    <AccountResetPwd v-if="status === 'resetPwd'" @back="status = 'login'" />
  </div>
</template>
<script lang="ts" setup>
import SelectAccount from '~/features/account/select/selectModal.vue';
import AccountLogin from '~/pages/login/features/login-form/ui/Base.vue';
import WechatLogin from '~/pages/login/features/login-form/ui/LoginWechat.vue';
import AccountResetPwd from '~/pages/login/features/reset-password/index.vue';
import { isChinese } from '~/utils/area';
import { emitter, EVENT } from '~/utils/eventbus';

type Status = 'login' | 'resetPwd';

const emit = defineEmits(['next']);

const loginModeTooltip = computed(() => {
  return loginMode.value === 'pwd' ? '微信登录' : '手机号/账号登录'; // @xi18n-ignore
});

// 登录方式
type LoginMode = 'pwd' | 'wechat';

const loginMode = ref<LoginMode>(isChinese() ? 'wechat' : 'pwd');

function onChangeLoginModeClick() {
  loginMode.value = loginMode.value === 'pwd' ? 'wechat' : 'pwd';
}

const status = ref<Status>('login');

onMounted(() => {
  emitter.on(EVENT.SWITCH_WECHAT_LOGIN, () => (loginMode.value = 'wechat'));
  emitter.on(EVENT.FIND_PWD, () => (status.value = 'resetPwd'));
});
const open = ref(false);

function onSelect() {
  emit('next');
  open.value = false;
}

function onSelectAccount() {
  open.value = true;
}
</script>
<style lang="scss" scoped>
.operation-wrap {
  position: relative;
  padding: 70px 90px 40px;
  display: flex;
  justify-content: center;
  width: 600px;
  background: var(--login-operation-bg);
  border-radius: 20px;
  border: 1px solid var(--back-3);
}
.login-mode-switcher {
  position: absolute;
  right: 0;
  top: 0;
  width: 79px;
  height: 76px;
  cursor: pointer;

  &::after,
  &::before {
    position: absolute;
    content: ' ';
    width: 0;
    height: 0;
    right: 0;
    bottom: 0;
  }
  &::after {
    // 左下角白色三角形
    border-top: 76px solid transparent;
    border-right: 0 solid transparent;
    border-left: 79px solid var(--login-operation-bg);
    pointer-events: none;
  }
  &::before {
    // 右上角蓝色三角形
    border-bottom: 76px solid transparent;
    border-left: 0 solid transparent;
    border-right: 79px solid var(--purple-1);
  }
  iconpark-icon {
    position: absolute;
    font-size: 27px;
    color: var(--primary-color);
    right: 15px;
    top: 15px;
  }
}
</style>
